import { render } from "./TicketIndexBoard.vue?vue&type=template&id=6cef01ef"
import script from "./TicketIndexBoard.vue?vue&type=script&lang=js"
export * from "./TicketIndexBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__